<div class="center">
    <div class="spinner-border text-info">
        <span class="sr-only">Chargement en cours...</span>
    </div>
</div>
